<script setup lang="ts">
import { ref, Ref, watch } from 'vue'
import { useMeasurementStore } from '@/store/measurements'

const props = defineProps<{ measurement: string | null }>()

const availableTags: Ref<string[]> = ref([])

const model = defineModel<string[]>({ default: [] })
async function load() {
  if (!props.measurement) return
  availableTags.value = await useMeasurementStore().loadAvailableTagKeyForMeasurement(undefined, props.measurement)
  for (const tag of model.value) {
    if (!availableTags.value.includes(tag)) {
      model.value = model.value.filter(t => t !== tag)
    }
  }
}

watch(
  () => props.measurement,
  async () => {
    await load()
  },
  { immediate: true }
)
</script>

<template>
  <v-autocomplete
    v-model="model"
    prepend-icon="mdi-shape-square-rounded-plus"
    :label="$t('chart_sharing.creator.customize.group_by.title')"
    :multiple="true"
    variant="outlined"
    closable-chips
    chips
    :items="availableTags"
  />
</template>
